export const initialState = {
  userChoices: {
    chosenMeals: 0
  },
  utils: {
    loading: false,
    alertMessage: ""
  },
  firebaseStaticData: {}
};
